export default __webpack_public_path__ + "static/media/white_logo.896df737.png";